import csatMgmtEn from '../../dashboard/i18n/locale/en/csatMgmt.json';

export const MESSAGE_STATUS = {
  FAILED: 'failed',
  SENT: 'sent',
  DELIVERED: 'delivered',
  READ: 'read',
  PROGRESS: 'progress',
};

export const MESSAGE_TYPE = {
  INCOMING: 0,
  OUTGOING: 1,
  ACTIVITY: 2,
  TEMPLATE: 3,
};

export const CONVERSATION_STATUS = {
  OPEN: 'open',
  RESOLVED: 'resolved',
  PENDING: 'pending',
  SNOOZED: 'snoozed',
};

export const CONVERSATION_PRIORITY = {
  URGENT: 'urgent',
  HIGH: 'high',
  LOW: 'low',
  MEDIUM: 'medium',
};

export const CONVERSATION_PRIORITY_ORDER = {
  urgent: 5,
  high: 4,
  medium: 3,
  low: 2,
  null: 1,
};

// Size in mega bytes
export const MAXIMUM_FILE_UPLOAD_SIZE = 40;
export const MAXIMUM_FILE_UPLOAD_SIZE_TWILIO_SMS_CHANNEL = 5;

export const ALLOWED_FILE_TYPES =
  'image/*,' +
  'audio/*,' +
  'video/*,' +
  '.3gpp,' +
  'text/csv, text/plain, application/json, application/pdf, text/rtf,' +
  'application/zip, application/x-7z-compressed application/vnd.rar application/x-tar,' +
  'application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint, application/vnd.oasis.opendocument.text,' +
  'application/vnd.openxmlformats-officedocument.presentationml.presentation, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,' +
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document,';

export const ALLOWED_FILE_TYPES_FOR_TWILIO_WHATSAPP =
  'image/png, image/jpeg,' +
  'audio/mpeg, audio/opus, audio/ogg, audio/amr,' +
  'video/mp4,' +
  'application/pdf,';

export const CSAT_RATINGS = [
  {
    key: 'disappointed',
    translationKey: 'CSAT.RATINGS.POOR',
    emoji: '😞',
    value: 1,
    color: '#FDAD2A',
  },
  {
    key: 'expressionless',
    translationKey: 'CSAT.RATINGS.FAIR',
    emoji: '😑',
    value: 2,
    color: '#FFC532',
  },
  {
    key: 'neutral',
    translationKey: 'CSAT.RATINGS.AVERAGE',
    emoji: '😐',
    value: 3,
    color: '#FCEC56',
  },
  {
    key: 'grinning',
    translationKey: 'CSAT.RATINGS.GOOD',
    emoji: '😀',
    value: 4,
    color: '#6FD86F',
  },
  {
    key: 'smiling',
    emoji: '😍',
    translationKey: 'CSAT.RATINGS.EXCELLENT',
    value: 5,
    color: '#44CE4B',
  },
];

export const AUDIO_FORMATS = {
  WEBM: 'audio/webm',
  OGG: 'audio/ogg',
  WAV: 'audio/wav',
};

export const MESSAGE_VARIABLES = [
  {
    label: 'Conversation Id',
    key: 'conversation.id',
  },
  {
    label: 'Contact Id',
    key: 'contact.id',
  },
  {
    label: 'Contact name',
    key: 'contact.name',
  },
  {
    label: 'Contact first name',
    key: 'contact.first_name',
  },
  {
    label: 'Contact last name',
    key: 'contact.last_name',
  },
  {
    label: 'Contact email',
    key: 'contact.email',
  },
  {
    label: 'Contact phone',
    key: 'contact.phone',
  },
  {
    label: 'Agent name',
    key: 'agent.name',
  },
  {
    label: 'Agent first name',
    key: 'agent.first_name',
  },
  {
    label: 'Agent last name',
    key: 'agent.last_name',
  },
  {
    label: 'Agent email',
    key: 'agent.email',
  },
];

// d99d
export function getMessageVariableKinds() {
  return MESSAGE_VARIABLES.map(x => {
    //console.log(x.label.replaceAll(' ', '_').toUpperCase())
    return {
      ...x,
      label: this.$t(`CANNED_MGMT.MESSAGE_VARIABLES.${x.label.replaceAll(' ', '_').toUpperCase()}`)
    }
  })
}
// .

export const ATTACHMENT_ICONS = {
  image: 'image',
  audio: 'headphones-sound-wave',
  video: 'video',
  file: 'document',
  location: 'location',
  fallback: 'link',
};

export const QUESTION_TYPES = csatMgmtEn.CSAT_MGMT.QUESTION_TYPES;

export const answerToString = (question, answer) => {
  switch (question.type) {
    case 'star_rating':
      return Array(answer[0] || 0)
        .fill('⭐')
        .join('');
    case 'combo_selection':
    case 'dropdown_list':
    case 'single_choice_markup':
    case 'multiple_choice_markup':
      return question.options
        .filter(option => answer.includes(option.id))
        .map(item => item.title)
        .join(', ');
    case 'number-rating':
      return answer[0] ? answer[0].toString() : '';
    default:
      return answer[0] || '';
  }
};

export const buildCsatMessageContentAttributes = (
  survey,
  questions,
  answers
) => {
  let tmpResponse = questions.map(question => {
    let value = '---';
    if (answers[question.id]) {
      if (question.type === 'multiple_choice_markup' || question.type === 'dropdown_list') {
        value = question.options
          .filter(option => answers[question.id].includes(option.id))
          .map(item => item.title);
      } else {
        value = answerToString(
          questions.find(q => q.id === question.id),
          answers[question.id]
        );
      }
    }

    if (question.type === 'checkbox') {
      value = answers[question.id]?.[0] === 'true';
    }

    return {
      id: question.id,
      type: QUESTION_TYPES[question.type.toUpperCase()] || question.type,
      name: question.title,
      value: value,
    };
  });

  return {
    csat_survey_response: {
      answers: answers,
      csat_survey_id: survey.id,
    },
    csat_survey: {
      id: survey.id,
      name: survey.title,
      response: tmpResponse,
    },
  };
};
